module.exports = "<div class=\"modal-body\" *ngIf=\"fileUrl\">\n  <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"activeModal.dismiss()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n  <figure class=\"figure\">\n      <img [src]=\"fileUrl\" class=\"figure-img img-fluid rounded\" alt=\"\">\n  </figure>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/preview-image/preview-image.component.html
// module id = ../../../../../src/app/preview-image/preview-image.component.html
// module chunks = main